import { render, staticRenderFns } from "./TicketType.vue?vue&type=template&id=93a66788&scoped=true"
import script from "./TicketType.vue?vue&type=script&lang=js"
export * from "./TicketType.vue?vue&type=script&lang=js"
import style0 from "./TicketType.vue?vue&type=style&index=0&id=93a66788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a66788",
  null
  
)

export default component.exports